import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RouteNames } from "../../../navigation/RouteNames";
import {
  loginUser,
  loginWithFacebook,
  loginWithGoogle,
} from "../../../store/slices/authSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useTranslation } from "../../../translations/i18n";
import { getFacebookAccessToken } from "../../../services/facebookAuthService";
import { AuthUserRole } from "../../../models/ResponseModels/AuthUserResponse";
import { isCleaner } from "../../../utils/helperFunctions/roleHelper";

export const useLoginScreen = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { loading, socialLoading, error } = useAppSelector(
    (state) => state.auth,
  );

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const goToDefaultRoute = (role?: AuthUserRole | null) => {
    navigate(isCleaner(role) ? RouteNames.cleaningTasks : RouteNames.calendar, {
      replace: true,
    });
  };

  const handleLogin = async (event?: FormEvent) => {
    event?.preventDefault();

    const result = await dispatch(loginUser({ email, password }));

    if (loginUser.fulfilled.match(result)) {
      goToDefaultRoute(result.payload.user.role);
    }
  };

  const handleGoogleLoginSuccess = async (credential?: string) => {
    if (!credential) {
      return;
    }

    const result = await dispatch(
      loginWithGoogle({
        id_token: credential,
      }),
    );

    if (loginWithGoogle.fulfilled.match(result)) {
      goToDefaultRoute(result.payload.user.role);
    }
  };

  const handleFacebookLogin = async () => {
    const accessToken = await getFacebookAccessToken();

    const result = await dispatch(
      loginWithFacebook({
        access_token: accessToken,
      }),
    );

    if (loginWithFacebook.fulfilled.match(result)) {
      goToDefaultRoute(result.payload.user.role);
    }
  };

  return {
    email,
    password,
    setEmail,
    setPassword,

    loading,
    socialLoading,
    error: error || "",

    handleLogin,
    handleGoogleLoginSuccess,
    handleFacebookLogin,

    goToRegister: () => navigate(RouteNames.register),
    goToForgotPassword: () => navigate(RouteNames.forgotPassword),

    t,
  };
};
